import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import api from '../utils/api';
import sar from "../assets/logo/printlogo.png"
import jus from "../assets/logo/Justic.jpg"


const Login = () => {
  // State variables
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [otpValues, setOtpValues] = useState(['', '', '', '', '', '']);
  const [otpFromServer, setOtpFromServer] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [useOtp, setUseOtp] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [isHovering, setIsHovering] = useState(false);
  const [headerHover, setHeaderHover] = useState(false);

  const navigate = useNavigate();
  const otpInputsRef = useRef([]);
  const mainCardRef = useRef(null);

const [companyName, setCompanyName] = useState(localStorage.getItem("companyName") || "");
const [logo1, setLogo1] = useState(localStorage.getItem("logo1") || "");
const [logo2, setLogo2] = useState(localStorage.getItem("logo2") || "");

  // Handle OTP input changes
  const handleOtpChange = (index, value) => {
    if (!/^[0-9]?$/.test(value)) return;

    const newOtpValues = [...otpValues];
    newOtpValues[index] = value;
    setOtpValues(newOtpValues);

    if (value && index < 5) {
      otpInputsRef.current[index + 1]?.focus();
    }

    // Auto-submit when last digit is entered
    if (value && index === 5) {
      const enteredOtp = newOtpValues.join('');
      if (enteredOtp.length === 6) {
        handleVerifyOtp();
      }
    }
  };

  const handleOtpKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !otpValues[index] && index > 0) {
      otpInputsRef.current[index - 1]?.focus();
    }
  };

  // Check if user is already logged in
  useEffect(() => {
    const loggedInUser = localStorage.getItem('loggedInUser');
    if (loggedInUser) {
      navigate('/admin-dashboard2');
    }
  }, [navigate]);

  useEffect(() => {
    fetchData();
  }, []);

async function fetchData() {
  try {
    const fd = new FormData();
    fd.append("programType", "getCompanyDetails");

    const response = await api.post("settings/setting", fd);
    // console.log("API Response:", response);

    const data = response.data.data;

    const company = data.company_name;
    const logo1Url = data.logo_url;
    const logo2Url = data.logo2_url;
    const faviconUrl = data.favicon_url;

    // set state
    setCompanyName(company);
    setLogo1(logo1Url);
    setLogo2(logo2Url);

    // save in localStorage
    localStorage.setItem("companyName", company);
    localStorage.setItem("logo1", logo1Url);
    localStorage.setItem("logo2", logo2Url);
    localStorage.setItem("favicon", faviconUrl);

    // ✅ Set favicon dynamically
    if (faviconUrl) {
      const link =
        document.querySelector("link[rel*='icon']") ||
        document.createElement("link");

      link.type = "image/x-icon";
      link.rel = "shortcut icon";
      link.href = faviconUrl;

      document.getElementsByTagName("head")[0].appendChild(link);
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}

useEffect(() => {
  const favicon = localStorage.getItem("favicon");

  if (favicon) {
    const link =
      document.querySelector("link[rel*='icon']") ||
      document.createElement("link");

    link.type = "image/x-icon";
    link.rel = "shortcut icon";
    link.href = favicon;

    document.getElementsByTagName("head")[0].appendChild(link);
  }
}, []);


  // Get OTP function
  const handleGetOtp = async (e) => {
    if (e) e.preventDefault();
    if (!username.trim()) {
      toast.error('Please enter a username');
      return;
    }

    setLoading(true);
    const fd = new FormData();
    fd.append('username', username);
    fd.append('programType', 'verifyAndSendOTP');

    try {
      const response = await api.post('auth/authCurl', fd);
      const data = response.data;

      if (data.status === true && data.code === '200') {
        setOtpSent(true);
        setOtpFromServer(data.otp);
        toast.success('OTP sent successfully! Please check your registered mobile.');
        setOtpValues(['', '', '', '', '', '']);
        setTimeout(() => {
          otpInputsRef.current[0]?.focus();
        }, 100);
      } else {
        toast.error(data.data || 'Unable to send OTP. Please try again.');
      }
    } catch (error) {
      toast.error('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  // Verify OTP function
  const handleVerifyOtp = async (e) => {
    if (e) e.preventDefault();

    const enteredOtpString = otpValues.join('').trim();
    const otpFromServerString = String(otpFromServer).trim();

  

    setLoading(true);

    if (enteredOtpString === otpFromServerString) {
      const fd = new FormData();
      fd.append('programType', 'verifyOTP');
      fd.append('username', username);
      fd.append('otpNumber', enteredOtpString);
      // fd.entries().forEach(([key, value]) => { console.log(`${key}: ${value}`); });

      try {
        const response = await api.post('auth/authCurl', fd);

        // console.log('OTP Verification Response:', response);
        const data = response.data;

        if (data.status === true && data.code === '200') {
          localStorage.setItem('role', data.role || 'user');
          localStorage.setItem('loggedInUser', data.username || username);
          localStorage.setItem('authToken', 'kasejfksjdhfywterjwefbdskgfhsdfjh');

          toast.success('Login Successful!');
          setTimeout(() => {
            navigate('/admin-dashboard2');
            navigate(0);
          }, 1000);
        } else {
          toast.error('OTP verification failed');
        }
      } catch (error) {
        toast.error('Error verifying OTP');
      }
    } 
    setLoading(false);
  };

  // Login with password function
  const handleLoginWithPassword = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password.trim()) {
      toast.error('Please enter both username and password');
      return;
    }

    setLoading(true);

    try {
      const fd = new FormData();
      fd.append('username', username);
      fd.append('password', password);
      fd.append('programType', 'loginWithPassword');

      const response = await api.post('auth/authCurl', fd);
      const data = response.data;

      if (data.status === true && data.code === '200') {
        localStorage.setItem('role', data.role || 'user');
        localStorage.setItem('loggedInUser', data.username || username);
        localStorage.setItem('authToken', 'kasejfksjdhfywterjwefbdskgfhsdfjh');

        toast.success('Login Successful!');
        setTimeout(() => navigate('/admin-dashboard2'), 1000);
      } else {
        toast.error('Invalid credentials');
      }
    } catch (error) {
      toast.error('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  // Toggle between OTP and Password login
  const toggleLoginMethod = (method) => {
    if (method === 'otp') {
      setUseOtp(true);
      setOtpSent(false);
    } else {
      setUseOtp(false);
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        position: 'relative',
        background: 'linear-gradient(135deg, #e3f2fd 0%, #dbe5ff 40%, #c8ddff 100%)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0',
        overflow: 'hidden',
      }}
    >
      {/* Background blur overlay */}
      <div
        style={{
          content: '""',
          position: 'absolute',
          inset: 0,
          background: 'rgba(255,255,255,0.3)',
          backdropFilter: 'blur(6px)',
          zIndex: 0,
        }}
      />

      {/* HEADER - Exact same as inspiration */}
      <div
        style={{
          width: '100%',
          padding: '0',
          position: 'sticky',
          top: 0,
          zIndex: 10,
        }}
      >
        <div
          onMouseEnter={() => setHeaderHover(true)}
          onMouseLeave={() => setHeaderHover(false)}
          style={{
            width: '100%',
            padding: '8px 24px 8px 24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            background: 'rgba(255,255,255,0.75)',
            backdropFilter: 'blur(14px)',
            border: '1px solid rgba(255,255,255,0.4)',
            boxShadow: headerHover
              ? '0 12px 28px rgba(0,0,0,0.12)'
              : '0 8px 20px rgba(0,0,0,0.06)',
            transition: 'all 0.25s ease',
          }}
        >
          {/* LOGO LEFT */}
              {/* JUSTICE IMAGE RIGHT */}
          <div style={{ display: 'flex', alignItems: 'center' }}>

            <img
              src={logo1 || sar}
              alt="log1"
              style={{ width: "60px", height: "60px", objectFit: "contain" }}
            />

          </div>
        
          {/* TITLE CENTER */}
          <div
            style={{
              flex: 1,
              textAlign: 'center',
              padding: '0 24px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {/* Desktop Title */}
            <h1
              style={{
                fontWeight: '700',
                background: 'linear-gradient(135deg, #19314a 0%, #283781 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                color: 'transparent',
                letterSpacing: '0.5px',
                lineHeight: '1.2',
                margin: '0 0 4px 0',
                fontSize: '2.1rem',
                display: 'none', // Hide on mobile
              }}
              className="desktop-title"
            >
              {companyName || "Company Name"}
            </h1>

            {/* Mobile Title (2 lines) */}
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                lineHeight: '1.1',
              }}
              className="mobile-title"
            >
              <h2
                style={{
                  fontWeight: '800',
                  background: 'linear-gradient(135deg, #19314a 0%, #283781 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                  color: 'transparent',
                  fontSize: '1rem',
                  margin: '0',
                }}
              >
                Sarvajna & Justice
              </h2>
              <h3
                style={{
                  fontWeight: '700',
                  background: 'linear-gradient(135deg, #19314a 0%, #283781 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                  color: 'transparent',
                  fontSize: '0.9rem',
                  margin: '0',
                }}
              >
                Shivaraj Patil PU College
              </h3>
            </div>
          </div>

      

            <div style={{ display: 'flex', alignItems: 'center' }}>
            <img
              src={logo2 || jus}
              alt="logo2"
              style={{ borderRadius: "50%", width: "60px", height: "60px" }}
            />

          </div>

        </div>
      </div>

      {/* Main Content Area */}
      <div
        style={{
          flex: 1,
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '20px',
          position: 'relative',
          zIndex: 1,
        }}
      >
        {/* Main Login Card */}
        <div
          ref={mainCardRef}
          onMouseEnter={() => setIsHovering(true)}
          onMouseLeave={() => setIsHovering(false)}
          style={{
            width: '100%',
            maxWidth: '480px',
            background: 'rgba(255,255,255,0.82)',
            backdropFilter: 'blur(20px)',
            borderRadius: '16px',
            border: '1px solid rgba(255,255,255,0.4)',
            boxShadow: isHovering
              ? '0 32px 64px rgba(0,0,0,0.2)'
              : '0 24px 48px rgba(0,0,0,0.15)',
            overflow: 'hidden',
            transition: 'all 0.3s ease',
            transform: isHovering ? 'translateY(-4px)' : 'translateY(0)',
            position: 'relative',
          }}
        >
          {/* Top Gradient Bar */}
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: '6px',
              background: 'linear-gradient(135deg, #0d6efd 0%, #283781 100%)',
              zIndex: 2,
            }}
          />

          <div style={{ padding: '40px' }}>
            {/* Login Card Header */}
            <div style={{ textAlign: 'center', marginBottom: '32px' }}>

              <h1
                style={{
                  fontWeight: '800',
                  background: 'linear-gradient(135deg, #1e535f 0%, #283781 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                  color: 'transparent',
                  marginBottom: '8px',
                  fontSize: '28px',
                  lineHeight: '1.2',
                }}
              >
                Welcome Back
              </h1>

              <p
                style={{
                  color: '#1e535f',
                  opacity: '0.7',
                  fontSize: '16px',
                  margin: 0,
                }}
              >
                Login to continue to your dashboard
              </p>
            </div>

            {/* Login Method Toggle */}
            <div
              style={{
                display: 'flex',
                borderRadius: '12px',
                overflow: 'hidden',
                marginBottom: '32px',
                background: '#f8f9ff',
                border: '1px solid rgba(13, 110, 253, 0.1)',
              }}
            >
              <button
                type="button"
                onClick={() => toggleLoginMethod('otp')}
                style={{
                  flex: 1,
                  padding: '12px 16px',
                  border: 'none',
                  background: useOtp ? 'linear-gradient(135deg, #0d6efd 0%, #283781 100%)' : 'transparent',
                  color: useOtp ? '#ffffff' : '#0d6efd',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  fontWeight: '600',
                  fontSize: '15px',
                  position: 'relative',
                }}
                onMouseEnter={(e) => {
                  if (!useOtp) {
                    e.currentTarget.style.background = 'rgba(13, 110, 253, 0.05)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!useOtp) {
                    e.currentTarget.style.background = 'transparent';
                  }
                }}
              >
                Login with OTP
              </button>
              <button
                type="button"
                onClick={() => toggleLoginMethod('password')}
                style={{
                  flex: 1,
                  padding: '12px 16px',
                  border: 'none',
                  background: !useOtp ? 'linear-gradient(135deg, #0d6efd 0%, #283781 100%)' : 'transparent',
                  color: !useOtp ? '#ffffff' : '#0d6efd',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  fontWeight: '600',
                  fontSize: '15px',
                }}
                onMouseEnter={(e) => {
                  if (useOtp) {
                    e.currentTarget.style.background = 'rgba(13, 110, 253, 0.05)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (useOtp) {
                    e.currentTarget.style.background = 'transparent';
                  }
                }}
              >
                Login with Password
              </button>
            </div>

            {/* Username Field */}
            <div style={{ marginBottom: '24px' }}>
              <label
                style={{
                  fontWeight: '600',
                  marginBottom: '8px',
                  display: 'block',
                  color: '#1e535f',
                  fontSize: '15px',
                }}
              >
                Username
              </label>
              <div
                style={{
                  position: 'relative',
                }}
              >
                <div
                  style={{
                    position: 'absolute',
                    left: '12px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: '#0d6efd',
                  }}
                >
                  <svg style={{ width: '20px', height: '20px' }} fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                  </svg>
                </div>
                <input
                  type="text"
                  placeholder="Enter your username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  disabled={loading}
                  style={{
                    width: '100%',
                    padding: '12px 12px 12px 40px',
                    borderRadius: '8px',
                    border: '1px solid #ddd',
                    background: 'rgba(255,255,255,0.9)',
                    fontSize: '16px',
                    transition: 'all 0.3s ease',
                    outline: 'none',
                  }}
                  onFocus={(e) => {
                    e.currentTarget.style.borderColor = '#0d6efd';
                    e.currentTarget.style.boxShadow = '0 0 0 2px rgba(13, 110, 253, 0.1)';
                  }}
                  onBlur={(e) => {
                    e.currentTarget.style.borderColor = '#ddd';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                />
              </div>
            </div>

            {/* OTP Login Section */}
            {useOtp && (
              <div
                style={{
                  opacity: useOtp ? 1 : 0,
                  transform: useOtp ? 'translateY(0)' : 'translateY(-10px)',
                  transition: 'opacity 0.3s ease, transform 0.3s ease',
                }}
              >
                {otpSent ? (
                  <>
                    <div style={{ marginBottom: '24px' }}>
                      <label
                        style={{
                          fontWeight: '600',
                          marginBottom: '12px',
                          display: 'block',
                          color: '#1e535f',
                          fontSize: '15px',
                        }}
                      >
                        Enter 6-digit OTP
                      </label>
                      <div
                        style={{
                          display: 'flex',
                          gap: '12px',
                          justifyContent: 'center',
                        }}
                      >
                        {otpValues.map((value, index) => (
                          <input
                            key={index}
                            ref={(el) => (otpInputsRef.current[index] = el)}
                            type="text"
                            maxLength="1"
                            value={value}
                            onChange={(e) => handleOtpChange(index, e.target.value)}
                            onKeyDown={(e) => handleOtpKeyDown(index, e)}
                            disabled={loading}
                            style={{
                              width: '56px',
                              height: '56px',
                              textAlign: 'center',
                              fontSize: '20px',
                              fontWeight: '600',
                              borderRadius: '8px',
                              border: '2px solid #ddd',
                              background: 'rgba(255,255,255,0.9)',
                              outline: 'none',
                              transition: 'all 0.3s ease',
                            }}
                            onFocus={(e) => {
                              e.currentTarget.style.borderColor = '#0d6efd';
                              e.currentTarget.style.boxShadow = '0 0 0 3px rgba(13, 110, 253, 0.1)';
                            }}
                            onBlur={(e) => {
                              e.currentTarget.style.borderColor = '#ddd';
                              e.currentTarget.style.boxShadow = 'none';
                            }}
                          />
                        ))}
                      </div>
                    </div>
                  </>
                ) : (
                  <div style={{ marginBottom: '24px' }}>
                    <p
                      style={{
                        textAlign: 'center',
                        color: '#1e535f',
                        opacity: '0.7',
                        marginBottom: '16px',
                        fontSize: '14px',
                      }}
                    >
                      Enter your username to receive OTP
                    </p>
                  </div>
                )}
              </div>
            )}

            {/* Password Login Section */}
            {!useOtp && (
              <div
                style={{
                  opacity: !useOtp ? 1 : 0,
                  transform: !useOtp ? 'translateY(0)' : 'translateY(-10px)',
                  transition: 'opacity 0.3s ease, transform 0.3s ease',
                }}
              >
                <div style={{ marginBottom: '24px' }}>
                  <label
                    style={{
                      fontWeight: '600',
                      marginBottom: '8px',
                      display: 'block',
                      color: '#1e535f',
                      fontSize: '15px',
                    }}
                  >
                    Password
                  </label>
                  <div style={{ position: 'relative' }}>
                    <div
                      style={{
                        position: 'absolute',
                        left: '12px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        color: '#0d6efd',
                      }}
                    >
                      <svg style={{ width: '20px', height: '20px' }} fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <input
                      type={showPassword ? 'text' : 'password'}
                      placeholder="Enter your password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      disabled={loading}
                      style={{
                        width: '100%',
                        padding: '12px 40px 12px 40px',
                        borderRadius: '8px',
                        border: '1px solid #ddd',
                        background: 'rgba(255,255,255,0.9)',
                        fontSize: '16px',
                        transition: 'all 0.3s ease',
                        outline: 'none',
                      }}
                      onFocus={(e) => {
                        e.currentTarget.style.borderColor = '#0d6efd';
                        e.currentTarget.style.boxShadow = '0 0 0 2px rgba(13, 110, 253, 0.1)';
                      }}
                      onBlur={(e) => {
                        e.currentTarget.style.borderColor = '#ddd';
                        e.currentTarget.style.boxShadow = 'none';
                      }}
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      style={{
                        position: 'absolute',
                        right: '12px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        background: 'none',
                        border: 'none',
                        color: '#666',
                        cursor: 'pointer',
                        padding: '4px',
                      }}
                    >
                      {showPassword ? (
                        <svg style={{ width: '20px', height: '20px' }} fill="currentColor" viewBox="0 0 20 20">
                          <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                          <path fillRule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clipRule="evenodd" />
                        </svg>
                      ) : (
                        <svg style={{ width: '20px', height: '20px' }} fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M3.707 2.293a1 1 0 00-1.414 1.414l14 14a1 1 0 001.414-1.414l-1.473-1.473A10.014 10.014 0 0019.542 10C18.268 5.943 14.478 3 10 3a9.958 9.958 0 00-4.512 1.074l-1.78-1.781zm4.261 4.26l1.514 1.515a2.003 2.003 0 012.45 2.45l1.514 1.514a4 4 0 00-5.478-5.478z" clipRule="evenodd" />
                          <path d="M12.454 16.697L9.75 13.992a4 4 0 01-3.742-3.741L2.335 6.578A9.98 9.98 0 00.458 10c1.274 4.057 5.065 7 9.542 7 .847 0 1.669-.105 2.454-.303z" />
                        </svg>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Submit Button */}
            <button
              type="button"
              onClick={
                useOtp
                  ? otpSent
                    ? handleVerifyOtp
                    : handleGetOtp
                  : handleLoginWithPassword
              }
              disabled={loading || (useOtp && otpSent && otpValues.join('').length !== 6)}
              style={{
                width: '100%',
                padding: '16px',
                borderRadius: '8px',
                border: 'none',
                background: 'linear-gradient(135deg, #0d6efd 0%, #283781 100%)',
                boxShadow: '0 6px 20px rgba(13, 110, 253, 0.4)',
                color: '#ffffff',
                fontWeight: '700',
                fontSize: '16px',
                cursor: loading ? 'not-allowed' : 'pointer',
                letterSpacing: '0.5px',
                transition: 'all 0.3s ease',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                opacity: loading ? 0.7 : 1,
              }}
              onMouseEnter={(e) => {
                if (!loading && !(useOtp && otpSent && otpValues.join('').length !== 6)) {
                  e.currentTarget.style.boxShadow = '0 12px 28px rgba(13, 110, 253, 0.5)';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.background = 'linear-gradient(135deg, #0b5ed7 0%, #223270 100%)';
                }
              }}
              onMouseLeave={(e) => {
                if (!loading && !(useOtp && otpSent && otpValues.join('').length !== 6)) {
                  e.currentTarget.style.boxShadow = '0 6px 20px rgba(13, 110, 253, 0.4)';
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.background = 'linear-gradient(135deg, #0d6efd 0%, #283781 100%)';
                }
              }}
              onMouseDown={(e) => {
                if (!loading && !(useOtp && otpSent && otpValues.join('').length !== 6)) {
                  e.currentTarget.style.transform = 'translateY(0)';
                }
              }}
            >
              {loading ? (
                <>
                  <div
                    style={{
                      width: '20px',
                      height: '20px',
                      border: '2px solid rgba(255,255,255,0.3)',
                      borderTop: '2px solid white',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite',
                    }}
                  />
                  Processing...
                </>
              ) : useOtp ? (
                otpSent ? (
                  <>
                    <svg style={{ width: '20px', height: '20px' }} fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    Verify & Login
                  </>
                ) : (
                  <>
                    <svg style={{ width: '20px', height: '20px' }} fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z" clipRule="evenodd" />
                    </svg>
                    Get OTP
                  </>
                )
              ) : (
                <>
                  <svg style={{ width: '20px', height: '20px' }} fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M3 3a1 1 0 011 1v12a1 1 0 11-2 0V4a1 1 0 011-1zm7.707 3.293a1 1 0 010 1.414L9.414 9H17a1 1 0 110 2H9.414l1.293 1.293a1 1 0 01-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Login with Password
                </>
              )}
            </button>

            {/* Helper Text */}
            <p
              style={{
                display: 'block',
                textAlign: 'center',
                marginTop: '24px',
                color: '#1e535f',
                opacity: '0.7',
                fontSize: '14px',
              }}
            >
              {useOtp
                ? 'OTP will be sent to your registered mobile number'
                : 'Enter your username and password to login'}
            </p>
          </div>
        </div>
      </div>

      {/* Inline CSS for animations and responsive behavior */}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
        input:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
        
        button:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
        
        input[type="number"]::-webkit-inner-spin-button,
        input[type="number"]::-webkit-outer-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
        
        input[type="number"] {
          -moz-appearance: textfield;
        }
        
        /* Responsive styles for header */
        @media (min-width: 600px) {
          .desktop-title {
            display: block !important;
          }
          .mobile-title {
            display: none !important;
          }
        }
        
        @media (max-width: 599px) {
          .desktop-title {
            display: none !important;
          }
          .mobile-title {
            display: flex !important;
          }
          
          /* Adjust header padding for mobile */
          .header-content {
            padding: 4px 16px 4px 16px !important;
          }
          
          .logo-image, .justice-image {
            width: 48px !important;
            height: 48px !important;
          }
          
          .justice-image {
            width: 52px !important;
            height: 52px !important;
          }
        }
        
        @media (max-width: 400px) {
          .login-card-content {
            padding: 24px !important;
          }
          
          .otp-input {
            width: 40px !important;
            height: 40px !important;
            font-size: 16px !important;
          }
        }
      `}</style>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
};

export default Login;